import store from '@/store/store'
import router from '../routes/router'
import { getLoginModuleData } from '@/services/API/module/ModuleService'
import { getLoginTokenRequest } from '@/services/API/auth/AuthRequestService'

/**
 * Constant with error code from backend
 */
const UNAUTHORIZED_ERROR_CODE = 401

/**
 * @description
 * Make actions before send axios request.
 * In this case, this function add bypass param to request if
 * the Vue Environment Var "VUE_APP_BY_PASS_LOGIN" is "true",
 *
 * @param {Object} config
 * @return {Object} config
 */
const beforeRequest = config => {
    // Do something before request is sent
    if (process.env.VUE_APP_BY_PASS_LOGIN === 'true') {
        if (config.params == undefined) config.params = {} // For query with Models
        addByPassParam(config)
    }
    addCashDeskToken(config)
    return config
}

/**
 * @description
 * Error request to backend,
 *
 * @param {Object} response
 * @return {Promise} response
 */
const errorRequest = function(error) {
    return new Promise(function(resolve, reject) {
        let moduleToken = getModuleToken_FromParams()
        if (
            error.respose &&
            error.response.status === UNAUTHORIZED_ERROR_CODE &&
            moduleToken === undefined
        ) {
            // ignore guard if exist token in URL
            getLoginModuleData() // Go to mod_login
                .then(response => {
                    store.dispatch('AuthModule/logoutActions') // delete local storage user data
                    let urlLoginModule = response.data.g_login_module.url_module
                    window.location = urlLoginModule
                })
                .catch(err => {
                    console.log('Error get Module URL')
                })
        } else {
            if (!localStorage.getItem('user-token'))
                getLoginTokenRequest({ module_token: moduleToken })
                    .then(response => {
                        store.dispatch('AuthModule/loginActions', response) // create local storage user data
                        resolve(response)
                    })
                    .catch(e => {
                        let message = 'Error de autenticación'
                        console.log(e.response)
                        if (
                            e.response &&
                            e.response.data &&
                            e.response.data.message
                        )
                            message = e.response.data.message
                        if (
                            e.response &&
                            e.response.data &&
                            e.response.data.errors &&
                            e.response.data.errors.module_token
                        )
                            message =
                                'Token de caja no registrado en base de datos'
                        store.dispatch('SnackbarModalModule/initSnackbar', {
                            typeMessage: 'error',
                            message: {
                                title: 'ERROR',
                                body: message,
                            },
                            timeout: 6000,
                            showProgress: false,
                            showCloseBtn: false,
                            closeBtnMessage: 'cerrar',
                        })
                        setTimeout(() => router.push('/salir'), 4000)
                    })
        }
        throw error
    })
}

/**
 * @description
 * Get module token from params
 * @return {void}
 */
const getModuleToken_FromParams = () => {
    try {
        return window.location.search.substr(1).split('=')[1]
    } catch (err) {
        return undefined
    }
} // end function

function addByPassParam(config) {
    config.params.bypass = true
}
/**
 * @description
 * Add extra params to Rquest
 *
 * @param {Object} config
 * @return {void}
 */
function addCashDeskToken(config) {
    if (config.params == undefined) config.params = {} // For query with Models
    if (getCashDeskToken()) config.params.cash_desk_token = getCashDeskToken()
}

/**
 * @description
 * Get Cash Desk Workstation ID
 *
 * @return {int}
 */
function getCashDeskToken() {
    return localStorage.getItem('cash_desk_token')
}

export { beforeRequest, errorRequest }
